import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project, Resource, Task } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  tasks: Identifiable<Task>[];
  retrieveTasks(request: Boundaries["retrieveTasks"]["request"]): void;
}

function useTasksRetrieval(
  project: Identifiable<Project>,
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isTasksRetrievalRequestPending(project, resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isTasksRetrievalRequestSuccess(project, resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isTasksRetrievalRequestFailure(project, resource),
    ),
    tasks: useSelector(() => selector.getTasks(project, resource)),
    retrieveTasks: core.retrieveTasks,
  };
}

export { useTasksRetrieval };
